module.exports = __webpack_public_path__ + "static/img/co-operate-01.215bc76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/co-operate-01.png
// module id = bgqX
// module chunks = 1